'use client';

import { SchoolDetailsComponent } from './SchoolDetailsComponent';

export function SchoolDetailsComponentC(
  props: React.ComponentProps<typeof SchoolDetailsComponent>,
) {
  return <SchoolDetailsComponent {...props} />;
}
